import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=844d5f58&"
import script from "./BaseBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImage: require('/opt/build/repo/storefront/components/atoms/Media/DynamicImage.vue').default})
